import React, { Component } from 'react';
import { Panel, Checkbox, Button } from 'react-bootstrap';
import '../../../content/css/PortfolioAnalysis/FilterPanel.css';
import CollapsibleFilterBox from './CollapsibleFilterBox';
import MultiRangeSlider from './MultiRangeSlider';
import SpinnerSelectControl from './SpinnerSelectControl';

export default class FilterPanel extends Component {
    constructor(props) {
        super(props);
    }

    handleReset = () => {
        this.props.onReset();
    }

    handleContractTypeFilter = (contractType) => {
        let filter = { ...this.props.filter };
        let shouldAdd = !filter.contractTypes.includes(contractType);
        if (shouldAdd)
            filter.contractTypes = [...new Set([...filter.contractTypes, contractType])];
        else
            filter.contractTypes = filter.contractTypes.filter(x => x !== contractType);

        this.props.onChange(filter);
    }

    handlePeriodChange = (conceptCode, min, max) => {
        let filter = { ...this.props.filter };
        filter.periods[conceptCode] = { min, max };
        this.props.onChange(filter);
    }

    handleConceptSelect = (conceptCode, state) => {
        let filter = { ...this.props.filter };
        filter.concepts[conceptCode] = state;

        this.props.onChange(filter);
    }

    handleGoverningLawSelect = (governingLaw) => {
        let filter = { ...this.props.filter };
        let shouldAdd = !filter.governingLaws.includes(governingLaw);
        if (shouldAdd)
            filter.governingLaws = [...new Set([...filter.governingLaws, governingLaw])];
        else
            filter.governingLaws = filter.governingLaws.filter(x => x !== governingLaw);

        this.props.onChange(filter);
    }

    renderConcepts = () => {
        let initialValue = (code) => this.props.filter.concepts[code] ? this.props.filter.concepts[code] : 0;
        let concepts = this.props.concepts.filter(x => x.isActive && x.code !== "G1_1");
        return concepts.map(x =>
            <div className="filter-item flex-container">
                <span>{x.name}</span>
                <SpinnerSelectControl
                    initialValue={initialValue(x.code)}
                    items={['Show all', 'Show only found', 'Show only missing']}
                    onChange={(index, value) => this.handleConceptSelect(x.code, index)}
                />
            </div>
        );
    }

    renderContractTypes = () => {
        let contractTypes = [["Procurement Agreement", 0], ["Customer Agreement", 1], ["Unknown", 2], ["NDA (Customer)", 3], ["NDA (Seller)", 4],
        ["NDA (Mutual)", 5], ["EULA (Customer)", 6], ["Terms & Conditions", 7], ["Distribution Agreement (Customer)", 8], ["Distribution Agreement (Seller)", 9],
        ["DPA (Controller)", 10], ["DPA (Seller)", 11], ["License Agreement (Customer)", 12], ["License Agreement (Seller)", 13],
        ["Sourcing of Goods (Customer)", 14], ["Sourcing of Goods (Seller)", 15], ["Service Agreement (Customer)", 16], ["Service Agreement (Seller)", 17]];
        contractTypes = contractTypes.filter(x => this.props.contractTypes.includes(x[1]));
        return contractTypes.map(x =>
            <Checkbox
                checked={this.props.filter.contractTypes.includes(x[1])}
                onChange={() => this.handleContractTypeFilter(x[1])}
            >{x[0]}</Checkbox>
        );
    }

    renderInsights = () => {
        let insights = Object.values(this.props.insights);
        return insights.map(x =>
            <Checkbox onChange={() => this.handleConceptSelect(x.type)}>{x.title}</Checkbox>
        );
    }

    renderGoverningLaw = () => {
        return this.props.governingLaws.map(x =>
            <Checkbox checked={this.props.filter.governingLaws.includes(x)} onChange={() => this.handleGoverningLawSelect(x)}>{x}</Checkbox>
        );
    }

    renderLanguages = () => {
        let languages = ["English", "Swedish", "Spanish", "German", "French", "Chinese", "Russian"];
        return languages.map(x =>
            <Checkbox onChange={() => this.handleConceptSelect(x)}>{x}</Checkbox>
        );
    }

    renderPeriods = () => {
        let allowedConcepts = ["W2", "P1", "Agreement_term"];
        let concepts = this.props.concepts.filter(x => allowedConcepts.includes(x.code));
        concepts = concepts.filter(x => x.isActive);
        let periodFilter = this.props.filter.periods;
        const roundUpToNearestFifty = (num) => Math.ceil(num / 50) * 50;

        let elements = concepts.map(x => {
            let max = this.props.periods[x.code] ? roundUpToNearestFifty(this.props.periods[x.code]) : 400;
            let startMin = periodFilter && periodFilter[x.code] ? periodFilter[x.code].min : 0;
            let startMax = periodFilter && periodFilter[x.code] ? periodFilter[x.code].max : max;
            return <MultiRangeSlider
                title={x.name}
                initialMin={startMin}
                initialMax={startMax}
                min={0}
                max={max}
                onChange={(min, max) => this.handlePeriodChange(x.code, min, max)}
            />
        });
        elements = elements.reduce((accumulator, currentValue, index) => {
            if (index < elements.length - 1) return accumulator.concat([currentValue, <hr />]);
            return accumulator.concat(currentValue);
        }, []);

        return elements;
    }

    render() {
        return (
            <Panel className="filter-panel">
                <div className="top">
                    <span className="title">Filters</span>
                    <Button bsSize="xsmall" onClick={this.handleReset}>Clear all</Button>
                </div>
                {!this.props.hideContractType &&
                    <React.Fragment>
                        <hr />
                        <CollapsibleFilterBox title="Contract types">
                            {this.renderContractTypes()}
                        </CollapsibleFilterBox>
                    </React.Fragment>
                }
                <hr />
                <CollapsibleFilterBox title="Periods & terms">
                    {this.renderPeriods()}
                </CollapsibleFilterBox>
                <hr />
                <CollapsibleFilterBox title="Governing law">
                    {this.renderGoverningLaw()}
                </CollapsibleFilterBox>
                <hr />
                <CollapsibleFilterBox title="Concepts">
                    {this.renderConcepts()}
                </CollapsibleFilterBox>
                {/*<hr />
                <CollapsibleFilterBox title="Dates">
                    <span>Test</span>
                </CollapsibleFilterBox>*/}
                {/*<hr />
                <CollapsibleFilterBox title="Insights">
                    {this.renderInsights()}
                </CollapsibleFilterBox>
                <hr />*/}
                {/*<hr />
                <CollapsibleFilterBox title="Languages">
                    {this.renderLanguages()}
                </CollapsibleFilterBox>*/}
            </Panel>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/AnalysisReports/FilterPanel/FilterPanel.js